import React, { useState } from 'react';

const PersonalDetailsForm = ({ data, onChange, onNext }) => {
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const validate = () => {
    const newErrors = {};
    if (!data?.fullName?.trim()) newErrors.fullName = 'Full name is required';
    if (!data?.phone?.trim()) newErrors.phone = 'Phone number is required';
    else if (!/^(\+?254|0)[17]\d{8}$/?.test(data?.phone?.replace(/\s/g, '')))
      newErrors.phone = 'Enter a valid Kenyan phone number';
    if (!data?.email?.trim()) newErrors.email = 'Email is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(data?.email))
      newErrors.email = 'Enter a valid email address';
    if (!data?.nationalId?.trim()) newErrors.nationalId = 'National ID is required';
    else if (data?.nationalId?.length < 7) newErrors.nationalId = 'Enter a valid national ID number';
    if (!data?.password?.trim()) newErrors.password = 'Password is required';
    else if (data?.password?.length < 8) newErrors.password = 'Password must be at least 8 characters';
    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (validate()) onNext();
  };

  const inputClass = (field) =>
    `w-full px-4 py-3 rounded-xl border-2 text-sm font-medium transition-all duration-200 outline-none bg-white text-gray-900 placeholder-gray-400 ${
      errors?.[field]
        ? 'border-red-400 focus:border-red-500' : 'border-gray-200 focus:border-yellow-400'
    }`;

  return (
    <div className="max-w-lg mx-auto">
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-2" style={{ color: '#0a1628' }}>
          Personal Details
        </h2>
        <p className="text-gray-500 text-sm">
          Tell us about yourself. This information will be used to verify your identity.
        </p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-5">
        {/* Full Name */}
        <div>
          <label className="block text-sm font-semibold mb-1.5" style={{ color: '#0a1628' }}>
            Full Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            placeholder="e.g. John Kamau Mwangi"
            value={data?.fullName || ''}
            onChange={(e) => onChange('fullName', e?.target?.value)}
            className={inputClass('fullName')}
          />
          {errors?.fullName && (
            <p className="text-red-500 text-xs mt-1">{errors?.fullName}</p>
          )}
        </div>

        {/* Phone */}
        <div>
          <label className="block text-sm font-semibold mb-1.5" style={{ color: '#0a1628' }}>
            Phone Number <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-sm font-semibold text-gray-500">
              🇰🇪
            </span>
            <input
              type="tel"
              placeholder="+254 7XX XXX XXX"
              value={data?.phone || ''}
              onChange={(e) => onChange('phone', e?.target?.value)}
              className={`${inputClass('phone')} pl-10`}
            />
          </div>
          {errors?.phone && (
            <p className="text-red-500 text-xs mt-1">{errors?.phone}</p>
          )}
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-semibold mb-1.5" style={{ color: '#0a1628' }}>
            Email Address <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            placeholder="john@example.com"
            value={data?.email || ''}
            onChange={(e) => onChange('email', e?.target?.value)}
            className={inputClass('email')}
          />
          {errors?.email && (
            <p className="text-red-500 text-xs mt-1">{errors?.email}</p>
          )}
        </div>

        {/* Password */}
        <div>
          <label className="block text-sm font-semibold mb-1.5" style={{ color: '#0a1628' }}>
            Password <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Min. 8 characters"
              value={data?.password || ''}
              onChange={(e) => onChange('password', e?.target?.value)}
              className={`${inputClass('password')} pr-12`}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors text-xs font-medium"
            >
              {showPassword ? 'Hide' : 'Show'}
            </button>
          </div>
          {errors?.password && (
            <p className="text-red-500 text-xs mt-1">{errors?.password}</p>
          )}
          <p className="text-gray-400 text-xs mt-1">
            You'll use this to log in to your driver dashboard
          </p>
        </div>

        {/* National ID */}
        <div>
          <label className="block text-sm font-semibold mb-1.5" style={{ color: '#0a1628' }}>
            National ID Number <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            placeholder="e.g. 12345678"
            value={data?.nationalId || ''}
            onChange={(e) => onChange('nationalId', e?.target?.value?.replace(/\D/g, ''))}
            maxLength={10}
            className={inputClass('nationalId')}
          />
          {errors?.nationalId && (
            <p className="text-red-500 text-xs mt-1">{errors?.nationalId}</p>
          )}
          <p className="text-gray-400 text-xs mt-1">
            Your ID number is encrypted and stored securely
          </p>
        </div>

        <button
          type="submit"
          className="w-full py-3.5 rounded-xl font-bold text-sm transition-all duration-200 hover:opacity-90 active:scale-95 shadow-lg mt-2"
          style={{ background: 'linear-gradient(135deg, #ffd700, #f59e0b)', color: '#0a1628' }}
        >
          Continue to Vehicle Info →
        </button>
      </form>
    </div>
  );
};

export default PersonalDetailsForm;
